module.exports = __webpack_public_path__ + "static/media/about-us-illustration.8dfaefe2.png";